import { HttpStatusCode } from "axios";
import freshmanConfigurationService from "../../apiServices/freshman/freshmanConfigurationService";
import { alertConstants } from "../../helper/sweet-alert";
import { IFreshmanConfigurationData } from "../../models/freshman/configuration";
import { setConfiguration, setConfigurations } from "../../store/slices/freshman/configurationSlice";
import { setInactiveVersion } from "../../store/slices/freshman/inactiveVersionSlice";

export function createFreshmanConfiguration(data: IFreshmanConfigurationData, callback: Function) {
  return async function (dispatch: any, getState: any) {
    let response = await freshmanConfigurationService.createConfiguration(data);
    if (response?.success === true) {
      callback(alertConstants.success);
    } else {
      if (response.status === HttpStatusCode.Conflict) {
        callback(alertConstants.conflict);
      } else {
        callback(alertConstants.error);
      }
    }
  };
}

export function getFreshmanConfiguration(studentCategoryId: number) {
  return async function (dispatch: any, getState: any) {
    let response = await freshmanConfigurationService.getFreshmanConfiguration(studentCategoryId);
    if (response?.success === true) {
      dispatch(setConfiguration(response.data));
    } else {
      console.log("error");
    }
  };
}

export function getAllFreshmanCofiguration() {
  return async function (dispatch: any, getState: any) {
    let response = await freshmanConfigurationService.getAllFreshmanCofiguration();
    if (response?.success === true) {
      dispatch(setConfigurations(response.data));
    } else {
      console.log("error");
    }
  };
}

export function updateFreshmanConfiguration(
  data: IFreshmanConfigurationData,
  studentCategoryId: number,
  callback: Function
) {
  return async function (dispatch: any, getState: any) {
    let response = await freshmanConfigurationService.updateFreshmanConfiguration(data, studentCategoryId);
    if (response?.success === true) {
      callback(alertConstants.success);
    } else {
      if (response.status === HttpStatusCode.Conflict) {
        callback(alertConstants.conflict);
      } else {
        callback(alertConstants.error);
      }
    }
  };
}

export function deleteFreshmanConfiguration(
  studentCategoryId: number,
  callback: Function
) {
  return async function (dispatch: any, getState: any) {
    let response = await freshmanConfigurationService.deleteFreshmanConfiguration(studentCategoryId);
    if (response === true) {
      callback(alertConstants.inactiveSuccess);
    } else {
      callback(alertConstants.inactiveFailure);
    }
  };
}

export function getAllInactiveVersion(studentCategoryId: number, versionId: number) {
  return async function (dispatch: any, getState: any) {
    let response = await freshmanConfigurationService.getAllInactiveVersion(studentCategoryId, versionId);
    if (response?.success === true) {
      dispatch(setConfiguration(response.data));
    } else {
      console.log("error");
    }
  };
}

